export default "__VITE_ASSET__BSgbKE$y__"